// extracted by mini-css-extract-plugin
module.exports = {"CamPlaceholder":"CamPlaceholder_CamPlaceholder__3bUgU","spinnerContainer":"CamPlaceholder_spinnerContainer__yHev8","loading":"CamPlaceholder_loading__K3uu_"};